import {
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  useDisclosure,
} from '@chakra-ui/react';

export default function CustomDrawer({ children, btn }) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Button _focus={{ border: 'none' }} size='sm' p='0' onClick={onOpen}>
        {btn}
      </Button>
      <Drawer p='0' isOpen={isOpen} placement='left' onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent bg='transparent'>
          <DrawerCloseButton color='#fff' />
          <DrawerBody p='0'>{children}</DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
}
